import { DiamondsScreen } from '@/screens/diamonds/DiamondsScreen'

export default function () {
  return <DiamondsScreen />
}
